import Button from '@mui/material/Button';
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { styled } from '@mui/system';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export const StyledIcon = styled(AccountCircleIcon)({
    width: 30,
    height: 30
});

/** @component
 * Creates a Sign in Button.
 * @returns {React.Element}
 * @constructor
 */
export const SignInButton = () => {
    const { loginWithRedirect } = useAuth0();
    return (
        <Button
            variant={'text'}
            endIcon={<StyledIcon />}
            onClick={() => {
                loginWithRedirect(); // Initiate the login process
            }}
            sx={{
                padding: 3
            }}
            data-analyticsid='sign-in'
        >
            Sign in
        </Button>
    );
};
